import { Button } from "@/components/ui/button";
import { Loader2, ExternalLink } from "lucide-react";

interface PlatformCardProps {
  name: string;
  description: string;
  id: string;
  isConnecting: boolean;
  connectingPlatform: string | null;
  onConnect: (platformId: string) => void;
}

export const PlatformCard = ({
  name,
  description,
  id,
  isConnecting,
  connectingPlatform,
  onConnect,
}: PlatformCardProps) => {
  return (
    <div className="flex items-center justify-between p-4 border rounded-lg">
      <div className="space-y-0.5">
        <div className="font-medium">{name}</div>
        <div className="text-sm text-muted-foreground">
          {description}
        </div>
      </div>
      <Button 
        variant="outline" 
        onClick={() => onConnect(id)}
        disabled={isConnecting}
      >
        {isConnecting && connectingPlatform === id && (
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
        )}
        <ExternalLink className="mr-2 h-4 w-4" />
        Connect
      </Button>
    </div>
  );
};